module.exports = __webpack_public_path__ + "static/media/1_3_maya_draisin.2b256c2.mp3";


//////////////////
// WEBPACK FOOTER
// ./src/assets/audio/1_3_maya_draisin.mp3
// module id = 3bmJ
// module chunks = 1